import React from 'react';
import { CampaignIcon, ChevronDownIcon } from '../icons';
import ViewMenu from './ViewMenu';

/**
 * CampaignColumn - Left column showing campaign search results
 */
const CampaignColumn = ({
  campaigns,
  isLoading,
  searchQuery,
  openViewMenuId,
  viewMenuPosition,
  getViewsForCampaign,
  onCampaignClick,
  onCampaignViewSelect,
  onToggleViewMenu,
}) => {
  return (
    <div className="unified-search-popup__column">
      <div className="unified-search-popup__column-header">
        <CampaignIcon size={12} />
        <span>Campaigns</span>
        <span className="unified-search-popup__count">
          {isLoading ? '...' : campaigns.length}
        </span>
      </div>
      <div className="unified-search-popup__list">
        {isLoading && !campaigns.length ? (
          <div className="unified-search-popup__empty">Searching...</div>
        ) : campaigns.length > 0 ? (
          campaigns.map(campaign => (
            <CampaignItem
              key={campaign.id}
              campaign={campaign}
              isMenuOpen={openViewMenuId === `campaign-${campaign.id}`}
              viewMenuPosition={viewMenuPosition}
              views={getViewsForCampaign(campaign.id)}
              onClick={() => onCampaignClick(campaign)}
              onViewSelect={(view) => onCampaignViewSelect(campaign, view)}
              onToggleViewMenu={(e) => onToggleViewMenu(e, campaign.id, 'campaign')}
            />
          ))
        ) : (
          <div className="unified-search-popup__empty">
            {searchQuery ? 'No campaigns found' : 'Type to search campaigns'}
          </div>
        )}
      </div>
    </div>
  );
};

/**
 * CampaignItem - Individual campaign result item
 */
const CampaignItem = ({
  campaign,
  isMenuOpen,
  viewMenuPosition,
  views,
  onClick,
  onViewSelect,
  onToggleViewMenu,
}) => {
  const progress = campaign.progress || 0;
  const isComplete = progress === 100;
  const hasCustomViews = views.some(v => !v.isDefault);

  return (
    <div
      className={`unified-search-popup__item unified-search-popup__item--campaign ${isComplete ? 'unified-search-popup__item--complete' : ''}`}
      onClick={onClick}
    >
      <div className="unified-search-popup__item-content">
        <div className="unified-search-popup__item-main">
          <span className="unified-search-popup__item-name">{campaign.name || 'Untitled'}</span>
          {campaign.path && (
            <span className="unified-search-popup__item-path unified-search-popup__item-path--campaign">from {campaign.path}</span>
          )}
        </div>
        <div className="unified-search-popup__item-actions">
          <button 
            className={`unified-search-popup__view-dropdown-btn ${isMenuOpen ? 'unified-search-popup__view-dropdown-btn--open' : ''}`}
            onClick={onToggleViewMenu}
            title="Open in view..."
          >
            Open in…
            <ChevronDownIcon size={10} />
          </button>
        </div>
      </div>
      {/* Progress Bar */}
      <div className="unified-search-popup__progress-bar">
        <div 
          className="unified-search-popup__progress-fill"
          style={{ width: `${progress}%` }}
        />
      </div>
      {/* View Selection Menu */}
      {isMenuOpen && viewMenuPosition && (
        <ViewMenu
          views={views}
          position={viewMenuPosition}
          onSelectView={onViewSelect}
          onStopPropagation={(e) => e.stopPropagation()}
        />
      )}
    </div>
  );
};

export default CampaignColumn;
